import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/circleci/repo/out/apps/global-admin-panel/application/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/home/circleci/repo/out/apps/global-admin-panel/application/layouts/empty.vue").then(m => m.default || m))
}